import { render, staticRenderFns } from "./formPhoneVerification.vue?vue&type=template&id=54c42e66&scoped=true&"
import script from "./formPhoneVerification.vue?vue&type=script&lang=js&"
export * from "./formPhoneVerification.vue?vue&type=script&lang=js&"
import style0 from "./formPhoneVerification.vue?vue&type=style&index=0&id=54c42e66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c42e66",
  null
  
)

export default component.exports